<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <span *ngFor="let option of control.options" class="radio-button-option">
      <input
        type="radio"
        [id]="option.id"
        [name]="control.key"
        [value]="option.key"
        [formControlName]="control.key"
        [attr.disabled]="option.disabled ? 'disabled' : null"
      />
      <label [for]="option.id" class="radio-button-option-label form-control-label">{{ option.value }}</label>
    </span>
  </div>
</div>
